import { Button, Row } from "antd";
import React from "react";
import BranchStyle from "./style";
import DevelopmentImg from "../../../assets/Icons/development-img.png";

const Branches = () => {
  return (
    <>
      <BranchStyle>
        <h1 className="user-menu-title">Branches</h1>
        <Row className="yet-designed-pages">
          <div className="yet-designed-pages">
            <p className="developement-content">
              Provide users with tailored learning through customizable branches
            </p>
            <span className="developement-span-content">
              Create unique training environments for different learners. Adapt
              every branch to its users by customizing its URL, theme, language,
              and more. One portal, limitless training flexibility.
            </span>
            <Button className="developement-add-button">Upgrade now</Button>
          </div>

          <img
            src={DevelopmentImg}
            alt={DevelopmentImg}
            className="yet-designed-pages-image"
          />
        </Row>
      </BranchStyle>
    </>
  );
};

export default Branches;
